/**
 * Collection Practice Guides Carousel
 * Uses shared initScrollSnapCarousel from utils.js
 */

(function () {
  "use strict";

  function init() {
    initScrollSnapCarousel({
      sectionSelector: ".collection-practice-guides",
      containerSelector: ".collection-practice-guides__products-container",
      itemsContainerSelector: "#collection-practice-guides-products-{sectionId}",
      itemSelector: ".collection-practice-guides__product-item",
      paginationSelector: "#collection-practice-guides-pagination-{sectionId}",
      dotClass: "collection-practice-guides__pagination-dot",
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
